import '.ax{position:relative;}.ssr-plugin'
import '.j5{width:64px;}.ssr-plugin'
import '.j6{height:64px;}.ssr-plugin'
import '.ar{flex-shrink:0;}.ssr-plugin'
import '.bc{position:absolute;}.ssr-plugin'
import '.j7{bottom:-4px;}.ssr-plugin'
import '.ht{right:-4px;}.ssr-plugin'
import '.gh{border-radius:50%;}.ssr-plugin'
import '.j8{border:2px solid var(--palette-white);}.ssr-plugin'
import '.ao{overflow:hidden;}.ssr-plugin'
import '.j9{width:32px;}.ssr-plugin'
import '.ja{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="ax j5 j6 ar"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="bc j7 ht gh j8 ao j9 ja"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
